<template>
    <section class="manage-cards-wrapper">
        <v-container class="pa-0">
            <v-col cols="12" class="pa-0">
                <div class="manage-card-text-group">
                    <div class="justify-center title-text">
                        Where can I manage my cards?
                    </div>
                    <div class="d-none  justify-center d-md-flex sub-text">
                        You can check your remaining balance and combine
                        balances below or use the corresponding navigation tabs
                        above.
                    </div>
                </div>
            </v-col>

            <v-row
                class="flex-column flex-md-row align-center justify-center ma-0"
            >
                <action-card
                    class="manage-card-first"
                    title="Check your card balance"
                    description="Enter the card's Pin to check your remaining balance."
                    to="/card/balance"
                    button-text="Go Now"
                    bg="pink-gradient"
                    icon="card1"
                    data-ga="Home Interaction|Card Balance"
                ></action-card>
                <action-card
                    class="manage-card-second"
                    title="Combine cards to do more"
                    description="Combine two or more cards to consolidate your funds and increase your balance."
                    to="/card/combine"
                    button-text="Go Now"
                    bg="blue-gradient"
                    icon="card2"
                    data-ga="Home Interaction|Card Combine"
                ></action-card>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import actionCard from '@/components/Home/action-card';
export default {
    name: 'manage-cards',
    components: { actionCard },
};
</script>

<style lang="scss" scoped>
.manage-cards-wrapper {
    position: relative;
    margin-bottom: 137px;
    .manage-card-text-group {
        padding-top: 110px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title-text {
            font-weight: 900;
            font-family: KlavikaNX-Medium, serif;
            font-size: 40px;
            padding-bottom: 50px;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
        }
        .sub-text {
            font-family: Roboto, serif;
            font-size: 16px;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: center;
            max-width: 580px;
            margin: 0 auto;
            padding-bottom: 67px;
        }
    }
    .manage-card-first {
        margin-bottom: 20px;
    }
    .manage-card-second {
        margin-bottom: 0;
    }
}
@media (min-width: 640px) {
    .manage-cards-wrapper {
        .manage-card-text-group {
            padding-top: 110px;
        }
    }
}
@include break('md') {
    .manage-cards-wrapper {
        min-height: 937px;
        margin-bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .manage-card-text-group {
            padding-top: 0;
            .title-text {
                font-size: 46px;
                padding-bottom: 25px;
            }
        }
    }
}

@include break('lg') {
    .manage-cards-wrapper {
        .manage-card-text-group {
            .title-text {
                font-size: 50px;
            }
        }
    }
}
@include break('xl') {
    .manage-cards-wrapper {
        margin-top: 105px;
        .manage-card-text-group {
            .title-text {
                font-size: 60px;
            }
            .sub-text {
                font-size: 20px;
                max-width: 700px;
            }
        }

        .manage-card-first {
            margin-bottom: 80px;
        }
    }
}

@media (max-width: 1920px) {
    .manage-card-first {
        margin-bottom: 67px;
    }
    .manage-card-second {
        margin-top: 80px;
    }
    .v-application .flex-md-row {
        flex-direction: row !important;
        padding: 0 30px;
    }
}
@media (max-width: 907px) {
    .manage-card-first,
    .manage-card-second {
        max-width: 100%;
        height: 350px;
    }
    .manage-card-first {
        margin-bottom: 20px;
    }
    .manage-card-second {
        margin: 0;
    }
}
</style>
